import { ShoppingCart, RotateCcw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

export default function SellDialog({ sellItem, sellForm, setSellForm, selling, canReturnToStock = true, onClose, onSave, onReturnToStock }) {
  const isSold = sellItem?.stock_status === "Sold";
  return (
    <Dialog open={!!sellItem} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="sell-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShoppingCart className="w-5 h-5 text-[#16A34A]" /> {isSold ? "Edit Sale" : "Sell Item"}</DialogTitle>
          <DialogDescription>{sellItem?.model_name} · {sellItem?.asset_id}</DialogDescription>
        </DialogHeader>
        {sellForm && (
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5 col-span-2">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Customer name *</Label>
              <Input value={sellForm.customer_name} onChange={(e) => setSellForm({ ...sellForm, customer_name: e.target.value })} data-testid="sell-customer" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Mobile</Label>
              <Input value={sellForm.mobile} onChange={(e) => setSellForm({ ...sellForm, mobile: e.target.value })} data-testid="sell-mobile" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Email</Label>
              <Input value={sellForm.email} onChange={(e) => setSellForm({ ...sellForm, email: e.target.value })} data-testid="sell-email" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Sale price *</Label>
              <Input type="number" min="0" value={sellForm.sale_price} onChange={(e) => setSellForm({ ...sellForm, sale_price: e.target.value })} className="font-mono" data-testid="sell-price" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Sale date</Label>
              <Input type="date" value={sellForm.sale_date} onChange={(e) => setSellForm({ ...sellForm, sale_date: e.target.value })} className="font-mono" data-testid="sell-date" />
            </div>
            <div className="space-y-1.5 col-span-2">
              <Label className="text-xs uppercase tracking-wide text-[#475569]">Remarks</Label>
              <Input value={sellForm.remarks} onChange={(e) => setSellForm({ ...sellForm, remarks: e.target.value })} placeholder="Warranty, payment mode, notes…" data-testid="sell-remarks" />
            </div>
          </div>
        )}
        <DialogFooter className="sm:justify-between">
          {isSold && canReturnToStock ? (
            <Button variant="outline" onClick={onReturnToStock} className="text-[#D97706] border-[#FCD34D] hover:bg-[#FFFBEB] gap-2" data-testid="return-to-stock-btn">
              <RotateCcw className="w-4 h-4" /> Return to stock
            </Button>
          ) : <span />}
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button onClick={onSave} disabled={selling} className="bg-[#16A34A] hover:bg-[#15803D] text-white gap-2" data-testid="sell-save">
              {selling ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShoppingCart className="w-4 h-4" />} {isSold ? "Update Sale" : "Mark as Sold"}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
